import { FoundationMenuEntry } from './frames.definition';

export function findMenu(data: any): FoundationMenuEntry[] | undefined {
  if (!data.body[0].block.length) {
    return;
  }
  const main_block = data.body[0].block.find((item: any) => {
    return item['@name'] && item['@name'] === '$MAIN$_BLOCK';
  });
  if (!main_block || !main_block.record || !main_block.record.length) {
    return;
  }
  if (!main_block.record[0].item || !main_block.record[0].item[1]) {
    return;
  }
  if (
    !main_block.record[0].item[1]['@name'] ||
    main_block.record[0].item[1]['@name'] !== 'MENU_TREE'
  ) {
    return;
  }
  const menu: FoundationMenuEntry[] =
    main_block.record[0].item[1].menu[0].entry;

  return menu;
}


export function findUserBlock(data: any): FoundationMenuEntry[] | undefined {
  if (!data.body[0].block.length) {
    return;
  }
  const infoBlock = data.body[0].block.find((item: any) => {
    return item['@name'] && item['@name'] === 'USER_INFO';
  });
  if (!infoBlock || !infoBlock.record || !infoBlock.record.length) {
    return;
  }
  if (!infoBlock.record[0].item || !infoBlock.record[0].item) {
    return;
  }

  return infoBlock.record[0].item;
}
